let isMobile = null;
let isDesktop = null;
let color = localStorage.getItem("color");
let organization = localStorage.getItem("organization");
let image = localStorage.getItem("image");

if(window.innerWidth <= 450){
    isMobile = true;
    isDesktop = false;
}else{
    isDesktop = true;
    isMobile = false;
}

const state = {
    isMobile: isMobile,
    isDesktop: isDesktop,
    color: color,
    organization: organization,
    image: image
};

export const mutations = {
    changeColor (color) {
        state.color = color
    },
    changeOrganization (org) {
        state.organization = org
    },
    changeImage (img) {
        state.image = img
    }
}

export default {
    namespaced: true,
    state,
    mutations
}
